/* eslint-disable jsx-a11y/no-distracting-elements */
import React from "react";
import style from "./gptmembers.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
  ADMIN_ID,
} from "../../Constant/Global";
import Loader from "../../components/loader/Loader";
import AOS from "aos";
import "aos/dist/aos.css";

const blurPlaceholder = "../../assets/images/blur_placeholder.webp";

const GtpMembers = () => {
  const [memberData, setMemberData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      offset: 200,
    });
  }, []);

  // gptMember api

  const handleMemberData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      // console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "web/grampanchayat_member",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      // console.log("member response", response.data.data);
      setIsLoading(false);
      setMemberData(response.data.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    handleMemberData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className={`container-fluid ${style.home_container_fluid}`}>
          {/* our village row  */}

          <div className={`row ${style.our_village_row}`}>
            <header className={`${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title}`}>
                Our village Grampanchayat
              </span>
              <h5 className={`${style.members_c_heading_title}`}>
                आपली ग्रामपंचायत
              </h5>
            </header>
            <div
              data-aos="fade-right"
              data-aos-duration="1500"
              className={`col-lg-5 ${style.our_village_first_column} pe-0`}
            >
              <div className={`${style.our_village_left_sec}`}>
                <img
                  src={memberData?.our_village_about?.image1 || blurPlaceholder}
                  alt="gpt-members"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
            <div className={`col-lg-3 ${style.our_village_middle_column}`}>
              <div className={`${style.our_village_middle_sec}`}>
                <img
                  src={memberData?.our_village_about?.image2 || blurPlaceholder}
                  alt="gpt-members"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
              <div className={`${style.our_village_middle_sec}`}>
                <img
                  src={memberData?.our_village_about?.image3 || blurPlaceholder}
                  alt="gpt-members"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="1500"
              className={`col-lg-4 ${style.our_village_last_column}`}
            >
              <div className={`${style.our_village_last_sec}`}>
                <p
                  className={`${style.o_v_last_sec_para}`}
                  dangerouslySetInnerHTML={{
                    __html: memberData?.our_village_about?.description,
                  }}
                />
              </div>
            </div>
          </div>

          {/* gram members row */}
          <div className={`row ${style.members_row}`}>
            <header className={`${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title}`}>Member’s</span>
              <h5 className={`${style.members_c_heading_title}`}>
                ग्रामपंचायत सदस्य <span>2023-24</span>
              </h5>
            </header>
            {memberData?.members?.map((ele) => {
              return (
                <div
                  key={ele.id}
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  className={`col-lg-4  col-md-6 ${style.members_column}`}
                >
                  <div className={`${style.members_col_common}`}>
                    <div className={`${style.members_col_left_sec}`}>
                      <div
                        className={`${style.background_img_set}`}
                        style={{
                          backgroundImage: `url('${ele.image}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                      <div className={`${style.m_c_l_s_bottom_sec}`}>
                        <p className={`${style.m_c_l_s_bottom_sec_para}`}>
                          {ele.title}
                        </p>
                        <span className={`${style.m_c_l_s_bottom_sec_span}`}>
                          {ele.role_name}
                        </span>
                      </div>
                    </div>
                    <div className={`${style.members_col_right_sec}`}>
                      <p
                        className={`${style.m_c_r_sec_para}`}
                        dangerouslySetInnerHTML={{
                          __html: ele.description,
                        }}
                      />
                      {/* <Link to="" className={`${style.member_read_more_btn}`}>
                        Read More
                      </Link> */}
                    </div>
                  </div>
                </div>
              );
            })}
            <div className={`${style.members_bottom_line}`}></div>
          </div>

          {/* important places row */}
          <div className={`row ${style.village_summary_row}`}>
            <header className={`${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title}`}>
                important place
              </span>
              <h5 className={`${style.members_c_heading_title}`}>
                प्रमुख स्थळे
              </h5>
            </header>
            {memberData?.important_places?.map((ele) => {
              return (
                <div
                  key={ele.id}
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  className={`col-lg-6 col-md-6 mb-5 ${style.place_col_left}`}
                >
                  <div className={`${style.important_place_left_sec}`}>
                    <div className={`${style.i_p_l_s_first}`}>
                      <img
                        src={require("../../assets/images/home/temple_hindu.png")}
                        alt="place"
                        className={`img-fluid ${style.temple_small_icon}`}
                        loading="lazy"
                      />
                      <span className={`${style.i_p_l_s_first_span}`}>
                        {ele.title}
                      </span>
                    </div>
                    <p
                      className={`${style.i_p_l_s_para}`}
                      dangerouslySetInnerHTML={{
                        __html: ele.description,
                      }}
                    />
                  </div>
                  <div className={`${style.important_place_right_sec}`}>
                    <div className={`${style.imp_place_r_s_first_d}`}>
                      <div
                        className={`${style.background_img_set_place}`}
                        style={{
                          backgroundImage: `url('${ele.image}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                    </div>
                    <div className={`${style.imp_place_r_s_second_d}`}>
                      <iframe
                        src={ele.map_url}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className={`${style.places_all_map}`}
                        title="place"
                      ></iframe>
                    </div>
                  </div>
                </div>
              );
            })}

            <hr className={`${style.place_hr}`} />
          </div>

          {/* Public facilities row */}
          <div className={`row ${style.public_facilities_row}`}>
            <header className={`${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title}`}>
                Public facilities
              </span>
              <h5 className={`${style.members_c_heading_title}`}>
                सार्वजनिक सुविधा
              </h5>
            </header>
            {memberData?.public_facility?.map((ele) => {
              return (
                <div
                  key={ele.id}
                  data-aos="fade-up"
                  data-aos-anchor-placement="top-center"
                  data-aos-duration="1500"
                  className={`col-lg-2  ${style.public_f_col}`}
                >
                  <div className={`${style.public_facilities_sec}`}>
                    <img
                      src={ele.image}
                      alt="facilities"
                      className="img-fluid"
                      loading="lazy"
                    />
                    <p className={`${style.public_facilities_sec_title_one}`}>
                      {ele.title}
                    </p>
                    <h2
                      className={`${style.public_facilities_sec_title_second}`}
                    >
                      {ele.count}
                    </h2>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default GtpMembers;
